import { useEffect, useState } from 'react';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { Navigate } from 'react-router-dom';

import Template from '#client/components/Template';
import { DEFAULT_ROUTE } from '#client/manifest';

const Callback = () => {
  const { authenticated, callback } = useAuthentication();
  const [loading, setLoading] = useState(true);
  const [redirectTo, setRedirectTo] = useState(DEFAULT_ROUTE);
  const [exception, setException] = useState(null);
  useEffect(() => {
    if (loading) {
      callback()
        .then((auth) => {
          if (auth?.redirectTo) {
            let redirectLocation = auth.redirectTo;
            // Check if this is an internal route to banking
            const bankingLocationPtr = redirectLocation.indexOf('/b/');

            // Strip any leading items from the route.
            if (bankingLocationPtr >= 0) {
              redirectLocation = redirectLocation.slice(bankingLocationPtr);
            }

            setRedirectTo(redirectLocation);
          } else {
            setRedirectTo('/b/');
          }
        })
        .catch((err) => {
          // Don't record exceptions for these error codes from Auth0
          setException(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [authenticated, loading, callback]);

  if (!redirectTo) {
    return null; // Wait until callback processed, then redirect to base page.
  }
  const showLoading = loading || !authenticated;
  if (showLoading) {
    // Wait until callback processed, then redirect to base page.
    return <Template />;
  }
  if (exception && exception.error === 'invalid_token') {
    return <Navigate to="/" />;
  }

  if (exception) {
    throw exception;
  }

  return <Navigate to={redirectTo} />;
};

export default Callback;
